import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import { Save } from '@mui/icons-material';

export default function FloatingSaveButton(props) {
  return (
    <Box onClick={()=>{if(!props.disabled) props?.onClick();}} style={{position: 'fixed', right: 14, bottom: 24, zIndex: 10000, opacity: props.disabled ? 0.4 : 1, pointerEvents: props.disabled ? 'none' : 'auto'}} sx={{ '& > :not(style)': { m: 1 } }}>
      <Fab size="medium" color={"primary"} aria-label="save" disabled={props.disabled}>
        <Save />
      </Fab>
    </Box>
  );
}